<button
  [attr.disabled]="(selected$ | async) ? 'disabled' : null"
  [attr.aria-label]="ariaPrefix ? (ariaPrefix + '.' + text | finLocalization) : ariaLabel"
  [ngClass]="{ 'white-text nordic-blue-900-bg': (selected$ | async) }"
  class="border ps-small ms-xsmall-r rounded-large white-bg medium-type font-body-1"
  (click)="onToggle()"
>
  {{ translationPrefix ? (translationPrefix + '.' + text | finLocalization) : text }}
</button>
